<template>
  <p class="dated-item" :style="{ animationDelay: delay + 's' }">
    <template v-if="content">
      <span class="dated-item-date" v-text="content.date" />
      {{ content.text }}
    </template>
  </p>
</template>

<script lang="ts" setup>
defineProps({
  delay: { type: Number, default: 0 },
  children: Array,
})

const slots = useSlots()

const content = computed(() => {
  const slot = slots.default && slots.default()
  if (!slot) return
  const str = slot[0]?.children as string
  // console.log(slots.default()[0].children)
  if (!str)
    return {
      number: '',
      text: '',
    }
  const [_s, date, _, text] = str.match(/(\d+)([\s|\.|-]*)(\w.+)/)
  return {
    date,
    text,
  }
})
</script>

<style lang="scss">
.dated-item {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 0.2em;
  margin-bottom: 0.5em;

  .dated-item-date {
    font-family: var(--font-emph);
    font-weight: bold;
    font-style: italic;
    margin-right: 2ch;
    color: var(--emph);
    min-width: 4ch;
    margin-top: -0.5em;
    // text-align: right;
    // font-variant-numeric: tabular-nums;
  }
}
</style>
